// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__tVl4U","buttons":"Footer_buttons__1VPg9"};